import React from "react";
import FeaturedPackages from "../page-components/home/FeaturedPackages";
import HeroSection from "../page-components/home/HeroSection";
import TestReponsive from "../page-essentials/TestReponsive";
import AboutNepal from "../page-components/home/AboutNepal";
import BookNowBanner from "../page-components/home/BookNowBanner";
import FeedbackFromClients from "../page-components/home/FeedbackFromClients";
import MessageUsSection from "../page-components/home/MessageUsSection";
import FeaturedCategories from "../page-components/home/FeaturedCategories";

const Home = () => {
  return (
    <div>
      {/* <TestReponsive /> */}

      <HeroSection />
      <AboutNepal />
      <FeaturedCategories />

      <FeaturedPackages />
      <BookNowBanner />
      <FeedbackFromClients />
      <MessageUsSection />
    </div>
  );
};

export default Home;
